import styled from "styled-components"
import media from "src/styles/media"

export const DepoimentosSliderWrapper = styled.section`
  position: relative;
  height: auto;
  width: 100%;
  z-index: 5;

  ${media.lessThan("md")`
        padding-bottom: 40px;
    `};

  .slick-slide {
    & > div {
      ${media.lessThan("lg")`
                display: flex;
                justify-content: center;
                align-items: center;
            `};
    }
  }

  .slick-dots {
    position: relative;
    text-align: left;
    margin-top: -15px;

    ${media.lessThan("lg")`
            text-align: center;
        `};

    li {
      width: 11px;
      height: 11px;
      transition: width 0.4s;
    }

    button {
      margin-top: -10px;
      display: block;
      width: 100%;
      height: 100%;
      background-color: var(--white);
      border-radius: 50%;
      transition: background-color 0.4s;

      &:before {
        display: none;
      }
    }

    .slick-active {
      width: 44px;

      button {
        background-color: var(--primary);
        border-radius: 5px;
      }
    }
  }
`
export const DepoimentosItem = styled.article`
  background-color: var(--white);
  color: var(--dark);
  transition: all 0.3s ease-in-out;
  width: 100%;
  border-radius: 15px;
  padding: 25px 30px;

  &:focus {
    outline: none;
  }

  ${media.lessThan("lg")`
        text-align: center;
        margin: 0 auto;
        padding: 20px 25px;
    `};
`

export const DepoimentosItemDesc = styled.p`
  font-weight: 300;
  font-size: 18px;
  line-height: 1.2;
  margin-bottom: 0;
  margin-bottom: 14px;

  ${media.lessThan("sm")`
        font-size: 15px;
    `}
`

export const DepoimentosItemAuthor = styled.p`
  font-weight: 600;
  font-size: 20px;
  line-height: 1.2;
  margin-bottom: 0px;
  text-align: inherit;

  ${media.lessThan("sm")`
        font-size: 16px;
    `}
`

export const DepoimentosItemPosition = styled.p`
  font-weight: 300;
  font-size: 17px;
  opacity: 0.8;
  line-height: 1.2;
  letter-spacing: 0.5px;
  margin-bottom: 5px;

  ${media.lessThan("sm")`
        font-size: 15px;
    `}
`

export const DepoimentosStars = styled.div`
  display: flex;
  color: #f7e516;

  svg {
    width: 25px;
  }

  ${media.lessThan("lg")`
      justify-content: center;
  `}
`

export const MasonryGrid = styled.div`
  column-count: 3;
  column-gap: 10px;

  ${media.lessThan("lg")`
      column-count: 2;
    `}

  ${media.lessThan("md")`
      column-count: 1;
    `}

  @media screen and (max-width: 400px) {
    column-count: 1;
  }
`

export const MasonryItem = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  margin-bottom: 10px;
  break-inside: avoid;

  &.full-width {
    display: block;
    width: 100%;
    text-align: center;

    ${DepoimentosStars} {
      justify-content: center;
    }

    @media screen and (min-width: 768px) {
      margin-top: 10px;
    }
  }
`
